/*
 * Module for the Beneficiaries Edit page
*/
rs.module("content/account/beneficiaries/edit",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, beneficiaryCount) {
            let nextId = beneficiaryCount;
            const addButton = $.js(jsSelectors.addButton);
            const beneficiariesDiv = $.js(jsSelectors.beneficiaries);

            $('#disclaimerModal').modal('show');

            addButton.on('click', function () {
                $.get(
                    backendUrls.newBeneficiary,
                    { index: nextId++ }
                ).done(function (data) {
                    beneficiariesDiv.append(data);
                });
            });

            $(document).on('click', '[data-remove-beneficiary]', function () {
                const index = $(this).data('remove-beneficiary');
                $(`[data-beneficiary-section="${index}"]`).hide();
                $(`[data-is-deleting="${index}"]`).val('True');
            });

            $(document).on('change', '[data-person-flag]', function () {
                const index = $(this).data('person-flag');
                const value = $(this).val() === 'True';
                $(`[data-tin-label="${index}"]`).text(value ? 'SSN' : 'TIN');

                if (value) {
                    $(`[data-person-name="${index}"]`).show();
                    $(`[data-nonperson-name="${index}"]`).hide();
                    $(`[data-birthdate-div="${index}"]`).show();
                    $(`[data-gender-div="${index}"]`).show();
                } else {
                    $(`[data-nonperson-name="${index}"]`).show();
                    $(`[data-person-name="${index}"]`).hide();
                    $(`[data-birthdate-div="${index}"]`).hide();
                    $(`[data-gender-div="${index}"]`).hide();
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);